export default {"src":"/_next/static/media/icone-quark.2e3bd27a.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};